import { useState } from 'react';
import { Grid } from '@mui/material';
import Table from '../../components/Table';
import CustomButton from 'components/Button';
import AddIcon from '@mui/icons-material/Add';
import SuccessErrorLessTime from 'components/SuccessErrorLessTime';
import { columOptions, tableOptionFilter, isAdmin, isUser, isAreaAdmin } from 'utils/utils';
import Loader from 'components/Loader';
import { useSelector } from 'react-redux';
import { authPostRequest, getAuthRequest } from 'Api/api';
import { useEffect } from 'react';
import DeleteSpan from 'components/DeleteSpan';
import DialogBox from '../../components/DialogBox';
import CreateAndUpdateBracketStrength from './CreateAndUpdateBracketStrength';
import CRUDActions from 'components/CRUDActions';
import SuperAdminView from 'pages/adminsView/SuperAdminView';
import { useNavigate } from 'react-router-dom';
import TextEllipsize from 'utils/TextEllipsize';

const columnOptionsStrengths = {
  setCellProps: () => ({ style: { maxWidth: '200px' } }),
  customBodyRender: (value) => <TextEllipsize value={value} length={30} />
};

const columns = [
  {
    name: 'bracketName',
    label: 'Name',
    options: columOptions,
    ...columnOptionsStrengths
  },

  {
    name: 'materialName',
    label: 'Material Type',
    options: columOptions
  },

  {
    name: 'sheathingName',
    label: 'Sheathing Type',
    options: columOptions
  },

  {
    name: 'fastenerName',
    label: 'Fastener Type',
    options: columOptions
  },
  {
    name: 'seamName',
    label: 'Seam Type',
    options: columOptions
  },
  {
    name: 'strength',
    label: 'Bracket Strength',
    options: columOptions
  }
];

const BracketStrengths = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [addOpenModal, setAddOpenModal] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showAlertBar, setShowAlertBar] = useState(false);
  const [isFormSaved, setIsFormSaved] = useState(false);
  const [successMessage, setSuccessMessage] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [bracket, setBracket] = useState();
  const [brackets, setBrackets] = useState();
  const [isDeleted, setIsDeleted] = useState(false);

  const { userData, adminAccess } = useSelector((store) => store.auth);
  const navigate = useNavigate();

  //For Open Dialog for delete Bracket
  const handleDialogOpen = (bracket) => {
    setBracket(brackets[bracket]);
    setOpenDialog(true);
  };

  //Open Dialog for update Bracket
  const handleOpenModal = (bracket) => {
    setBracket(brackets[bracket]);
    setAddOpenModal(true);
  };

  //Handle confirmation for delete
  const handleConfirm = async () => {
    try {
      const params = {
        userId: userData.userId,
        strengthId: bracket?.strengthId
      };
      setShowLoader(true);
      setShowAlertBar(false);
      setIsDeleted(false);
      const deleteBracket = await authPostRequest('deleteStrength', params);
      setShowLoader(false);
      if (deleteBracket.resStatus === 1) {
        setSuccessMessage([deleteBracket.resMessage]);
        setIsDeleted(true);
      } else {
        setErrorMessage([deleteBracket.resMessage]);
      }
      setIsFormSaved(true);

      setShowAlertBar(true);
      setOpenDialog(!openDialog);
      window.scrollTo(0, 0);
    } catch (err) {
      setShowLoader(false);
      setErrorMessage(['Error']);
      window.scrollTo(0, 0);
    }
  };

  //state set from delete bracket
  const handleDialogState = () => {
    setOpenDialog(!openDialog);
  };

  const getBracketStrengthList = async () => {
    try {
      setShowLoader(true);
      const list = await getAuthRequest('getStrengthsList');
      setBrackets(list?.strengthsList);
      setShowLoader(false);
    } catch (err) {
      setShowLoader(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getBracketStrengthList();
    if (isAdmin(userData?.roles) || isUser(userData?.roles) || isAreaAdmin(userData?.roles)) {
      if (adminAccess) {
        console.log('bracket-strength');
        navigate('/Error');
      } else navigate('/403');
    }
  }, [isFormSaved, isDeleted]);

  return (
    <>
      <SuperAdminView />
      <Grid display="flex" alignItems="center" justifyContent="flex-end">
        {showAlertBar && (
          <SuccessErrorLessTime
            successMessage={successMessage}
            errorMessage={errorMessage}
            setShowAlertBar={setShowAlertBar}
          />
        )}
        <CustomButton
          add={true}
          type="submit"
          endIcon={<AddIcon />}
          onClick={() => {
            setBracket({
              bracketId: '',
              materialId: '',
              sheathingId: '',
              fastenerId: '',
              seamId: '',
              strength: ''
            });
            setAddOpenModal(true);
          }}>
          Add
        </CustomButton>
      </Grid>

      <Table
        data={brackets}
        options={tableOptionFilter}
        columns={[
          ...columns,
          {
            name: 'Actions',
            lable: 'Actions',
            options: {
              ...columOptions,
              // Delete and Update Actions
              customBodyRender: (value, tableMeta) => {
                return (
                  <Grid sx={{ ml: '-1.5vh' }}>
                    <CRUDActions
                      onDelete={() => handleDialogOpen(tableMeta.rowIndex)}
                      onEdit={() => handleOpenModal(tableMeta.rowIndex)}
                    />
                  </Grid>
                );
              }
            }
          }
        ]}
      />

      {showLoader && <Loader open={showLoader} />}

      {openDialog && (
        <DialogBox
          handleDialogBoxState={handleDialogState}
          openDialogBox={openDialog}
          handleConfirmAction={handleConfirm}
          deleteMessage={
            <DeleteSpan message="strength of bracket" toBeDel={bracket?.bracketName} />
          }
        />
      )}

      {addOpenModal && (
        <CreateAndUpdateBracketStrength
          bracket={bracket}
          addOpenModal={addOpenModal}
          setAddOpenModal={setAddOpenModal}
          setSuccess={setSuccessMessage}
          setAlertBar={setShowAlertBar}
          setIsFormSaved={setIsFormSaved}
          isFormSaved={isFormSaved}
        />
      )}
    </>
  );
};

export default BracketStrengths;
